import { buildArticle } from "./_articleBuilder";

export default buildArticle({
  slug: "what-happens-if-antidepressants-dont-work",
  title: "What Happens If Antidepressants Don't Work?",
  description:
    "If antidepressants haven't provided enough relief, you're not out of options. Learn about treatment-resistant depression and interventional treatments like TMS, SAINT®, and SPRAVATO®.",
  keywords:
    "antidepressants not working, treatment-resistant depression, what if medication fails, next depression treatment",
  badge: "Educational Article",
  heroTitle: "What Happens If Antidepressants Don't Work?",
  heroSubtitle:
    "If you've tried antidepressants and are still experiencing depression, you are not out of options. There are treatments developed specifically for this situation.",
  sections: [
    {
      heading: "It's More Common Than You Think",
      body: "About a third of people with depression don't get adequate relief from oral antidepressants. That's not a small unlucky minority — it's a known limitation of how those medications work.",
    },
    {
      heading: "There's a Name for It",
      body: "Depression that hasn't responded adequately to one or more antidepressant trials is called treatment-resistant depression. It sounds like a judgment, but it isn't. It's a category that exists because this situation is common enough to need one.",
    },
    {
      heading: "Other Mechanisms Exist",
      body: "Treatments like TMS, SAINT®, and SPRAVATO® work through different mechanisms than oral antidepressants. That's the whole reason they exist — for people the standard approach hasn't reached.",
    },
    {
      heading: "What to Do Next",
      body: "If you've tried multiple antidepressants without adequate relief, a consultation can help you understand what other options may be appropriate. You don't need to have everything figured out before calling.",
      callout: true,
    },
  ],
  faq: [
    {
      question:
        "How many antidepressants do I need to try before other options?",
      answer:
        "There is no fixed number. Clinical criteria for treatment-resistant depression often reference two or more adequate trials. The decision to explore other options is made with your clinician based on your full history.",
    },
    {
      question: "Does trying other treatments mean giving up on medication?",
      answer:
        "Not necessarily. Interventional treatments may be used alongside medication or considered when medication alone hasn't been sufficient. Your prescriber helps coordinate your overall plan.",
    },
  ],
  related: [
    {
      title: "When Antidepressants Aren't Enough",
      href: "/when-antidepressants-dont-work",
    },
    {
      title: "What Is Treatment-Resistant Depression?",
      href: "/what-is-treatment-resistant-depression",
    },
    {
      title: "Depression Treatment Options",
      href: "/depression-treatment-options",
    },
  ],
  finalCtaText:
    "If antidepressants haven't worked, there are other approaches. Speak with our team about what may be appropriate.",
});
